export const SELECTION_UPPER_LIMIT = 8

// Fixed width reserved for the y-axis gutter, applied in the chart config via scales.y.afterFit
// Smaller than the public comps gutter because deal sizes top out in the hundreds of billions ($80B),
// so this component never needs room for the extra digit that $5,800B demands over there
// NOT mirrored exactly by the CSS: --transaction-logos-offset is deliberately a few px under this,
// because each label here is a pair of logos plus an arrow and is therefore wider than a single bar slot,
// so the row is started slightly before the first bar rather than flush with it
export const Y_AXIS_GUTTER_PX = 48

// Mobile counterpart of the gutter above, smaller because the y-axis tick font drops 11 -> 10 on mobile
export const Y_AXIS_GUTTER_MOBILE_PX = 44

export const TRANS_TILE_SECTIONS_LIST = [
    { id: 'size',      name: 'Size',      ids: ['dealSize'] },
    { id: 'operating', name: 'Operating', ids: ['ttmRevenueGrowth', 'ttmEbitdaMargin'] },
    { id: 'valuation', name: 'Valuation', ids: ['premiumPaid', 'ttmRevenueMultiple', 'ttmEbitdaMultiple'] },
]

export const TRANS_DEFAULT_MULT = "ttmRevenueMultiple"

export const TRANS_MULT_OPTIONS = [
    'ttmRevenueMultiple', 
    'ttmEbitdaMultiple' 
]

export const TC_TOOLTIP_TILE_COMPANION_DICTIONARY = {
    // ---- 1:1 ---- //    
    ttmRevenueGrowth:           [{ name: "LTM Revenue",      field: "ttmRevenue"        }],
    //currentRevenueGrowth:       [{ name: "Current Rev Est.", field: "currentYearRevEst" }],
    //forwardRevenueGrowth:       [{ name: "Forward Rev Est.", field: "nextYearRevEst"    }],
    //ttmGrossMargin:             [{ name: "LTM Gross Profit", field: "ttmGrossProfit"    }],
    ttmEbitdaMargin:            [{ name: "LTM EBITDA",       field: "ttmEbitda"         }],
    //currentEarningsGrowth:      [{ name: "Current EPS Est.", field: "currentYearEpsEst" }],
    //forwardEarningsGrowth:      [{ name: "Forward EPS Est.", field: "nextYearEpsEst"    }],
    //dividendYield:              [{ name: "Dividend / Share", field: "dividendAmount"    }],

    ttmRevenueMultiple:         [{ name: "LTM Revenue",      field: "ttmRevenue"        }],
    //currentYearRevenueMultiple: [{ name: "Current Rev Est.", field: "currentYearRevEst" }],
    //nextYearRevenueMultiple:    [{ name: "Forward Rev Est.", field: "nextYearRevEst"    }],
    ttmEbitdaMultiple:          [{ name: "LTM EBITDA",       field: "ttmEbitda"         }],
    ttmPeMultiple:              [{ name: "LTM EPS",          field: "ttmEps"            }],
    //currentYearPeMultiple:      [{ name: "Current EPS Est.", field: "currentYearEpsEst" }],
    //nextYearPeMultiple:         [{ name: "Forward EPS Est.", field: "nextYearEpsEst"    }]

    // ---- 1:2 ---- //
}